import { CanDeactivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

export interface LeaveConfirmGuard {
  canDeactivate: () => CanDeactivateType;
}

export const leaveConfirmGuard: CanDeactivateFn<LeaveConfirmGuard> =
  (component: LeaveConfirmGuard, _currentRoute, _currentState, _nextState): CanDeactivateType => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
